import type { FeatureListT } from "../components/MegaMenu/models/models";

const FEATURE_LIST: FeatureListT = [
  {
    // All the title keys are the same as on features page, except "download-page-title".
    // This key represents icon name also.
    titleKey: "instant-delivery-header",
    // All the description keys aren't the same, because they are should be shorter.
    descriptionKey: "instant-delivery-mega-menu-description",
    anchor: "instant-delivery",
    iconKey: "instant-delivery",
  },
  {
    titleKey: "security-title-header",
    descriptionKey: "security-mega-menu-description",
    anchor: "security-title",
    iconKey: "security-title",
  },
  {
    titleKey: "collabs-title-header",
    descriptionKey: "collabs-mega-menu-description",
    anchor: "collabs-title",
    iconKey: "collabs-title",
  },
  {
    titleKey: "send-big-files-title-header",
    descriptionKey: "send-big-files-mega-menu-description",
    anchor: "send-big-files-title",
    iconKey: "send-big-files-title",
  },
  {
    titleKey: "branding-title-header",
    descriptionKey: "download-page-mega-menu-description",
    anchor: "branding-title",
    iconKey: "download-page-title",
  },
  {
    titleKey: "inbox-title-header",
    descriptionKey: "inbox-mega-menu-description",
    anchor: "inbox-title",
    iconKey: "inbox-title",
  },
  {
    titleKey: "huge-file-storage-title-header",
    descriptionKey: "huge-file-storage-mega-menu-description",
    anchor: "send-big-files-title", // This anchor is wrong, due to the sctructure of the page and scroll to section logic.
    iconKey: "huge-file-storage-title",
  },
  {
    titleKey: "share-files-title-header",
    descriptionKey: "branding-mega-menu-description",
    anchor: "collabs-title",
    iconKey: "branding-title",
  },
  {
    titleKey: "manage-team-title-header",
    descriptionKey: "manage-team-mega-menu-description",
    anchor: "manage-team-title",
    iconKey: "manage-team-title",
  },
];

export default FEATURE_LIST;
